import React from "react";
import NOBannerImage from "src/assets/images/website-images/banner-of-non.jpg";

interface NOBannerProps {
  title?: string;
}

const NOBanner = ({ title }: NOBannerProps) => {
  return (
    <div className="w-full h-full relative flex items-center justify-center">
      <img
        src={NOBannerImage}
        alt=""
        className="w-full h-full object-cover absolute top-0 left-0"
      />
      <div className="w-full h-full absolute top-0 left-0 bg-black/10"></div>
      {title && (
        <h1 className="text-white z-10 relative border-white px-2 py-1 rounded-md underline underline-offset-4 font-size-25px font-Montserrat-SemiBold lowercase first-letter:uppercase">
          {title}
        </h1>
      )}
    </div>
  );
};

export default NOBanner;
